/**
 * InsuranceCompanyOptions
 * ───────────────────────
 * Jun 2026 — shared dropdown options for picking an insurance company
 * when adding insurance to a client.  Archived payers used to mix in
 * with active ones alphabetically, causing confusion.  Now: active
 * companies first (A→Z), then a divider and the archived ones grayed
 * out with an "archived" chip.  Archived stay selectable — historical
 * coverage entry is still legitimate.
 */
import React from 'react';
import { SelectItem } from '../ui/select';

const byName = (a, b) => a.name.localeCompare(b.name);

export const InsuranceCompanyOptions = ({ companies, searchTerm }) => {
  const term = (searchTerm || '').toLowerCase();
  const matches = (companies || []).filter(
    (ins) => (ins.name || '').toLowerCase().includes(term)
  );
  if (matches.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500">
        No insurance companies match "{searchTerm}"
      </div>
    );
  }
  const active = matches.filter((ins) => ins.status !== 'archived').sort(byName);
  const archived = matches.filter((ins) => ins.status === 'archived').sort(byName);
  return (
    <>
      {active.map((ins) => (
        <SelectItem key={ins.id} value={ins.name}>
          {ins.name}
        </SelectItem>
      ))}
      {archived.length > 0 && (
        <>
          <div
            className="px-2 pt-2 pb-1 mt-1 border-t text-[11px] uppercase tracking-wide text-gray-400 select-none"
            data-testid="archived-insurances-divider"
          >
            Archived
          </div>
          {archived.map((ins) => (
            <SelectItem
              key={ins.id}
              value={ins.name}
              className="text-gray-400 data-[highlighted]:text-gray-500"
              data-testid={`archived-insurance-option-${ins.id}`}
            >
              <span className="inline-flex items-center gap-1.5 text-gray-400">
                <span className="italic">{ins.name}</span>
                <span className="text-[10px] not-italic uppercase border border-gray-300 rounded px-1 py-px text-gray-400">
                  archived
                </span>
              </span>
            </SelectItem>
          ))}
        </>
      )}
    </>
  );
};
